.resizer {
  position: absolute;
}
